import { render, staticRenderFns } from "./TrueOrFalseConfig.vue?vue&type=template&id=1fc3658c&scoped=true&"
import script from "./TrueOrFalseConfig.vue?vue&type=script&lang=js&"
export * from "./TrueOrFalseConfig.vue?vue&type=script&lang=js&"
import style0 from "./TrueOrFalseConfig.vue?vue&type=style&index=0&id=1fc3658c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc3658c",
  null
  
)

export default component.exports